<template>
  <v-parallax height="264" src="@/assets/banner/dots.svg" alt>
    <v-container fluid>
      <v-row class="pt-2">
        <v-col cols="4" class="d-flex justify-space-around">
          <XsLoginButton />
          <XsRewardsButton
            v-if="authorized && includeLoyalty && (hasClubs || hasPoints)"
          />
        </v-col>
        <v-col cols="4" class="d-flex justify-center">
          <StorefrontImage size="small" />
        </v-col>
        <v-col cols="4" class="d-flex" style="justify-content: space-evenly">
          <v-btn fab x-small :to="{ name: 'about' }">
            <v-icon>mdi-information-outline</v-icon>
          </v-btn>
          <div class="position-relative">
            <Badge />
            <XsCartButton />
          </div>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col class="text-center">
          <h1
            class="color-black-magic font-size-md font-weight-semibold text-uppercase e2e-mobile-storename"
          >
            {{ wait(storeInfo, "name") }}
          </h1>
          <h2
            class="primary-color font-size-xs font-weight-semibold line-height-1"
          >
            <div class="e2e-mobile-address">
              {{ formatAddress(wait(storeInfo, "singleline")) }}
            </div>
            <div class="e2e-mobile-phone">
              {{ formatPhoneNumber(wait(storeInfo, "phone")) }}
            </div>
          </h2>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pa-0">
          <div class="slogan text-center black--text" style="width: 100%">
            {{ slogan }}
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <InactiveXsSearch />
        </v-col>
      </v-row>
    </v-container>
  </v-parallax>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { formatAddress, formatPhoneNumber, wait } from "@/util.js";
import Badge from "@/components/UI/Badge.vue";
import InactiveXsSearch from "@/components/Search/Xs/Inactive.vue";
import StorefrontImage from "@/components/UI/StorefrontImage.vue";
import XsCartButton from "@/components/Auth/Buttons/Xs/Cart.vue";
import XsLoginButton from "@/components/Auth/Buttons/Xs/Login.vue";
import XsRewardsButton from "@/components/Auth/Buttons/Xs/Rewards.vue";

export default {
  name: "XsHomeHeader",
  components: {
    Badge,
    InactiveXsSearch,
    StorefrontImage,
    XsCartButton,
    XsLoginButton,
    XsRewardsButton,
  },
  computed: {
    ...mapGetters("auth", { authorized: "isAuthenticated" }),
    ...mapGetters("store", { hasPoints: "hasPoints", hasClubs: "hasClubs" }),
    ...mapState({
      storeInfo: (state) => state.store.info,
      slogan: (state) =>
        state.store.info.store_info.customization?.website.style.slogan,
    }),
  },
  data() {
    return {
      includeLoyalty:
        process.env.VUE_APP_INCLUDE_LOYALTY.toLowerCase() === "true",
    };
  },
  methods: {
    formatAddress,
    formatPhoneNumber,
    wait,
  },
};
</script>
